import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { memo as Z, useState as f, useEffect as _ } from "react";
import { clsx as O } from "../../../node_modules/clsx/dist/clsx.m.js";
import Y from "../../molecules/Tab/Tab.js";
import x from "./Calender.module.scss.js";
import E from "../Button/Button.js";
import { getStartDate as z, getEndDate as A, tabItems as tt } from "./calender.helper.js";
import et from "../TimePicker/TimePicker.js";
import rt from "./components/SelectedDates.js";
import B from "./components/CalenderCell.js";
import ot from "../../../node_modules/lodash/isEmpty.js";
import st from "../../../node_modules/lodash/isArray.js";
import { i18n as R } from "../../../utils/locale/locale.js";
import { set as nt } from "../../../node_modules/date-fns/set.js";
import { addMonths as lt } from "../../../node_modules/date-fns/addMonths.js";
import { subDays as p } from "../../../node_modules/date-fns/subDays.js";
import { startOfWeek as W } from "../../../node_modules/date-fns/startOfWeek.js";
import { endOfWeek as q } from "../../../node_modules/date-fns/endOfWeek.js";
import { startOfMonth as H } from "../../../node_modules/date-fns/startOfMonth.js";
import { endOfMonth as I } from "../../../node_modules/date-fns/endOfMonth.js";
import { subMonths as P } from "../../../node_modules/date-fns/subMonths.js";
const at = ({
  size: o = "compact",
  type: i = "single",
  showShadow: $ = !0,
  footerActions: l,
  preSetRange: b,
  hasTimePicker: u,
  onChange: C,
  maxDate: j,
  minDate: D,
  events: T,
  disabledDates: S,
  disableWeekends: w,
  showMonthYearPicker: M,
  testId: v,
  value: s
}) => {
  var N;
  const [c, h] = f(
    Array.isArray(s) && s.length > 0 ? s[0] : s ? new Date(s) : /* @__PURE__ */ new Date()
  ), [n, y] = f([]), [F, k] = f(!0), [G, J] = f(-1), g = (N = document.querySelector("[class*=today]")) == null ? void 0 : N.firstChild, r = /* @__PURE__ */ new Date(), K = z(n), L = A(n), a = (t) => {
    y(t), C && C(i == "single" ? t[0] : t);
  };
  _(() => {
    if (s) {
      const t = st(s) ? s : [s];
      y(t);
    }
  }, [s]);
  const Q = (t) => {
    const d = [
      () => m(r),
      () => m(p(r, 1)),
      () => a([p(r, 7), r]),
      () => a([W(r), q(r)]),
      () => a([W(p(r, 7)), q(p(r, 7))]),
      () => a([H(r), I(r)]),
      () => a([H(P(r, 1)), I(P(r, 1))])
    ];
    d[t] && (d[t](), J(t));
  }, m = (t) => {
    if (i === "single")
      a([t]);
    else if (F)
      a([t]), k(!1);
    else if (n.length === 1) {
      const d = [n[0], t].sort((V, X) => V.getTime() - X.getTime());
      a(d), k(!0);
    }
  }, U = lt(c, 1);
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: O(x.calenderContainer, $ && x.calenderContainerShadow),
      "data-testid": v,
      children: [
        o === "extended" && i === "range" && b && /* @__PURE__ */ e.jsx("div", { className: "flex flex-col pl-200 py-150 border-0 border-r border-solid border-color-border-lightest ", children: /* @__PURE__ */ e.jsx(
          Y,
          {
            orientation: "vertical",
            tabs: tt,
            activeTab: G,
            onTabClick: Q
          }
        ) }),
        /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex rounded-t-small", children: [
            /* @__PURE__ */ e.jsx(
              B,
              {
                size: o,
                type: i,
                hasTimePicker: u,
                selectedDates: n,
                selectedMonth: c,
                currentMonth: c,
                maxDate: j,
                minDate: D,
                events: T,
                disabledDates: S,
                disableWeekends: w,
                onDateClick: m,
                setCurrentMonth: h,
                updateSelectedDates: a,
                showMonthYearPicker: M,
                showPreSetRange: b && o === "compact" && i === "range"
              }
            ),
            o === "extended" && i !== "single" && /* @__PURE__ */ e.jsx(
              B,
              {
                size: o,
                type: i,
                selectedDates: n,
                selectedMonth: U,
                maxDate: j,
                minDate: D,
                events: T,
                hasTimePicker: u,
                disabledDates: S,
                disableWeekends: w,
                currentMonth: c,
                showMonthYearPicker: M,
                onDateClick: m,
                setCurrentMonth: h
              }
            ),
            u && /* @__PURE__ */ e.jsx(
              et,
              {
                type: "multiSection",
                initialTime: n.length > 0 ? new Date(n[0]) : /* @__PURE__ */ new Date(),
                openTimePicker: !0,
                onTimeChange: (t) => m(
                  nt(n[0], { hours: t.getHours(), minutes: t.getMinutes() })
                ),
                withPortal: !1,
                hasTrigger: !1,
                disableCloseOut: !0
              }
            )
          ] }),
          l || o !== "compact" ? /* @__PURE__ */ e.jsxs("div", { className: x.footer, children: [
            o === "extended" && /* @__PURE__ */ e.jsx(
              rt,
              {
                type: i,
                showTodayButton: ot(l),
                starRangeDate: K,
                endRangeDate: L,
                disabledTodayButton: g == null ? void 0 : g.disabled,
                onChange: (t) => {
                  m(t), h(t);
                }
              }
            ),
            l && /* @__PURE__ */ e.jsxs("div", { className: O("flex gap-100 items-end", { "w-full": o === "compact" }), children: [
              /* @__PURE__ */ e.jsx(
                E,
                {
                  variant: "outlined",
                  color: "neutral",
                  size: "medium",
                  label: R("cancel"),
                  testId: "cancel-button",
                  fullWidth: o === "compact",
                  onClick: l == null ? void 0 : l.onCancel
                }
              ),
              /* @__PURE__ */ e.jsx(
                E,
                {
                  variant: "filled",
                  color: "primary",
                  size: "medium",
                  label: R("apply"),
                  testId: "apply-button",
                  fullWidth: o === "compact",
                  onClick: () => l == null ? void 0 : l.onClickApply(n)
                }
              )
            ] })
          ] }) : null
        ] })
      ]
    }
  );
}, Ot = Z(at);
export {
  Ot as default
};
//# sourceMappingURL=Calender.js.map
